import React from 'react';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { WorksheetAssociatedTestSection, WorksheetEquipmentDropdown } from '../../../../../Core';
import { IWorksheetComponent } from '../../../../../Core/types';
import { DryingEquipment, Phase } from '../../../../types';

import { Field, NumericInput, RadioGroup, TextInput, TextOutput } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { WorksheetBalanceFieldSet } from '../../../../../Core/WorksheetEquipment';

let SievingPreparationSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const dryingPhase = useSelector(createWorksheetSelector!('Preparation.DryingPhase')) as Phase;
  const washingPhase = useSelector(createWorksheetSelector!('Preparation.WashingPhase')) as Phase;
  const dryingEquipment = useSelector(
    createWorksheetSelector!('WholePortion.Masses.MassMeasurement.Equipment.DryingEquipment')
  ) as DryingEquipment;

  const isBeingDried = dryingPhase === Phase.WholePortion;
  const isBeingWashed = washingPhase === Phase.WholePortion;
  const measureWetMass = dryingPhase === Phase.AfterFirstSeparation || dryingPhase === Phase.AfterSecondSeparation;
  const measureDryMass = !measureWetMass;

  return (
    <>
      <ListFieldSection heading="Material Mass">
        <NamePrefixModifier appendNamePrefix="WholePortion.Masses">
          <NamePrefixModifier appendNamePrefix="MassMeasurement">
            <NamePrefixModifier appendNamePrefix="Equipment">
              {isBeingDried && (
                <>
                  <Field
                    input={<RadioGroup />}
                    label="Drying by"
                    name="DryingEquipment"
                    options={[
                      { label: 'Oven', value: DryingEquipment.Oven },
                      { label: 'Hotplate', value: DryingEquipment.Hotplate },
                    ]}
                  />
                  <div />
                </>
              )}
              <WorksheetBalanceFieldSet label="Balance" name="Balance" copyTo={['DryMassBalance']} />
              <Field
                input={<WorksheetEquipmentDropdown />}
                name="Oven"
                label="Oven"
                equipmentType="oven"
                visible={isBeingDried && dryingEquipment === DryingEquipment.Oven}
              />
              <Field
                input={<WorksheetEquipmentDropdown />}
                name="Hotplate"
                label="Hotplate"
                equipmentType="hotplate"
                visible={isBeingDried && dryingEquipment === DryingEquipment.Hotplate}
              />
            </NamePrefixModifier>
            <Field
              input={<TextInput />}
              name="TareID"
              label="Tare ID"
              visible={isBeingDried || (measureDryMass && measureWetMass)}
              maxLength={20}
            />
            <Field input={<NumericInput />} name="TareMass" label="Tare Mass" />
            <Field
              input={<NumericInput />}
              name="TareAndWetMass"
              label={`Tare and Portion Mass`}
              visible={measureWetMass}
            />
            <Field input={<TextOutput />} name="WetMass" label={`Portion Mass`} visible={measureWetMass} />
            <Field
              input={<NumericInput />}
              name="TareAndDryMass"
              label={`Tare and Portion Dry Mass`}
              visible={measureDryMass}
            />
            <Field input={<TextOutput />} name="DryMass" label={`Portion Dry Mass`} visible={measureDryMass} />
          </NamePrefixModifier>
          {/* Dry mass result field (when this isn't measured directly we want to show the calculated result here)*/}
          <Field input={<TextOutput />} name="DryMass" label={`Portion Dry Mass`} visible={!measureDryMass} />
        </NamePrefixModifier>
      </ListFieldSection>
      {isBeingWashed && (
        <WorksheetAssociatedTestSection
          testType="Wash"
          associatedTestModel={{
            measured: true,
          }}
          name="WholePortion.Washing.AssociatedWashTest"
        />
      )}
    </>
  );
};

SievingPreparationSection = withInjectedProps(SievingPreparationSection);

export { SievingPreparationSection };
export default SievingPreparationSection;
